import { Box, Stack } from "@origin-digital/ods-core";
import React from "react";
import { CategoriesSection } from "../CategoriesSection";
import { NeedHelp } from "src/components/NeedHelp";
import { OriginAppPromo } from "./OriginAppPromo";

export const ContentSection: React.FC = () => (
  <Box
    marginBottom={{ xs: "xxlarge", lg: "xxxlarge" }}
    paddingTop={{ lg: "large" }}
  >
    <Stack space={{ xs: "medium", lg: "large" }}>
      <CategoriesSection />
      <OriginAppPromo />
      <NeedHelp />
    </Stack>
  </Box>
);
